import { api } from './base';

import { MutationArg } from 'v2/types';
import { ModalModel } from 'v2/types/ModalModel';
import { SWRKeyValue } from 'v2/types/swr';

export const modalSettingsService = {
  getModals(): Promise<ModalModel[]> {
    return api.get('v1/admin/modal').json();
  },

  createModal(_key: string, { arg }: MutationArg<Omit<ModalModel, 'id'>>): Promise<ModalModel> {
    return api.post('v1/admin/modal', { json: arg }).json();
  },

  updateModal([_key, modalId]: SWRKeyValue, { arg }: MutationArg<Omit<ModalModel, 'id'>>): Promise<ModalModel> {
    return api.put(`v1/admin/modal/${modalId}`, { json: arg }).json();
  },

  deleteModal([_key, modalId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/modal/${modalId}`).json();
  },
};
